import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link"]

  connect() {
    if (this.hasLinkTarget) this.select(this.linkTargets[0])
  }

  activate(event) {
    this.select(event.currentTarget)
  }

  synchronize(event) {
    if (!customerDetailsFrame(event.target)) return

    const responseUrl = event.detail?.fetchResponse?.response?.url || event.target.src
    if (!responseUrl) return

    const responsePath = new URL(responseUrl, window.location.origin).pathname
    const activeLink = this.linkTargets.find((link) => new URL(link.href).pathname === responsePath)
    if (activeLink) this.select(activeLink)
  }

  select(activeLink) {
    this.linkTargets.forEach((link) => {
      link.classList.remove("active")
      link.removeAttribute("aria-current")
    })

    activeLink.classList.add("active")
    activeLink.setAttribute("aria-current", "page")
  }
}

function customerDetailsFrame(frame) {
  return frame?.id === "customer_details"
}
